import './style/bolmateSegmentedToggle.scss';

import React from 'react';

import classNames from 'classnames';

import {BolmateControlShape} from '../../../util/types';

export interface SegmentedToggleOption<T extends string> {
    value: T;
    label: string;
}

interface Props<T extends string> {
    options: Array<SegmentedToggleOption<T>>;
    value: T;
    onChange: (value: T) => void;
    /** Stretch to the container and split it evenly between the segments,
     *  instead of sizing each segment to its label. */
    fullWidth?: boolean;
    /** Rounded-rectangle instead of the default pill. Same vocabulary as the
     *  other controls (BolmateButton, PortalSelect). */
    shape?: BolmateControlShape;
    className?: string;
}

export default function BolmateSegmentedToggle<T extends string>({
    options,
    value,
    onChange,
    fullWidth,
    shape = 'rounded',
    className
}: Props<T>) {
    return (
        <div className={classNames('bolmate-segmented-toggle', `shape-${shape}`, fullWidth && 'full-width', className)}>
            {options.map(option => (
                <button
                    key={option.value}
                    className={classNames('segment-btn', value === option.value && 'active')}
                    onClick={() => onChange(option.value)}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
}
